import { EmailRegistrationForm } from "@/components/email-registration-form"
import { t } from "@/languages/i18n"
import { formatDateSimpleYyyyMmDd } from "@/lib/utils"
import { EventData } from "@/types/event"
import { EventInfoItem } from "./EventInfoItem"

interface EventInfoSidebarProps {
    event: EventData
}

const formatTime = (dateString: string | null): string => {
    if (!dateString) return "-------"
    try {
        const date = new Date(dateString)
        return date.toLocaleTimeString("vi-VN", { hour: "2-digit", minute: "2-digit" })
    } catch {
        return "-------"
    }
}

export const EventInfoSidebar = ({ event }: EventInfoSidebarProps) => {
    return (
        <div className="flex flex-col gap-4 sm:w-[38.6%] w-full">
            <EventInfoItem
                label={t("Day")}
                value={formatDateSimpleYyyyMmDd(event?.attributes?.date) || "-------"}
            />
            <EventInfoItem
                label={t("Time")}
                value={formatTime(event?.attributes?.date)}
            />
            <EventInfoItem
                label={t("Location")}
                value={event?.attributes?.location || "-------"}
            />
            <EventInfoItem
                label={t("Contact")}
                value={event?.attributes?.contact || "-------"}
            />
            <p className="text-base leading-[24.8px] text-[#333] opacity-50">
                {t("Confirm your attendance and receive event's info")}
            </p>
            <EmailRegistrationForm buttonText={t("Join")} />
        </div>
    )
}

